import sharedModule from '../../shared.module';

class CountryService {
    constructor($q, $sessionStorage, countryApiService) {
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.countryApiService = countryApiService;
    }

    getCountries() {
        if (this.$sessionStorage.countries) {
            return this.$q.resolve(this.$sessionStorage.countries);
        }

        var deferred = this.$q.defer();
        this.countryApiService.getCountries().then(data => {
            if (data && data.items && data.items.length > 0) {
                this.$sessionStorage.countries = data;
                deferred.resolve(data);
                return;
            }
            deferred.reject(data);
        }, deferred.reject);
        return deferred.promise;
    }
}

export default sharedModule.service('countryService', CountryService);



// WEBPACK FOOTER //
// ./modules/shared/services/country/country.service.js